module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-container', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1)])], 1), _vm._v(" "), _c('div', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_1.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_1.body)
    }
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.page.section_1.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.page.section_1.image
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('hr')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93109704","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/procurement-tabs/business-code-ethics/business-code-ethics.vue
// module id = 936
// module chunks = 0